
  
  
  
  
  import UMUM from "../library/umum";
  import DATA_MASTER from "../library/dataMaster";
  
  
  export default {
    props: ["mutasi_id", "nip"],
    data() {
      
      return {
        // xbiodata_id : this.biodata_id,
        list_riwayat: [],
        list_hukdis_siaAsn: [],
  
  
        form : {
            id : '',
            mutasi_id : this.mutasi_id,
            nip : '',
            uraian: '',
            userId : '',
            createdAt : '',
            status : 1,
            file : null,
            file_type : '',
        },

        hukdis : {
          hukdis_id : '',
          pnsOrangId : '',
          golonganId : '',
          biodata_id : this.biodata_id,
          jenisHukumanId : '',
          kedudukanHukumId : '',
          skNomor : '',
          skTanggal : '',
          hukumanTanggal : '',
          masaTahun : '',
          masaBulan : '',
          akhirHukumanTanggal : '',
          nomorPp : '',
          gol_lama : '',
          skPembatalanNomor : '',
          skPembatalanTanggal : '',
          alasanHukumanDisiplinId : '',
          nip : '',
          uraian: '',
          userId : '',
          createdAt : '',
          file : null,
          status : 1,
        },
  
        mdl_detil_riwayat: false,
        mdl_add: false,
  
        mdl_lampiran: false,
        mdl_edit: false,
        mdl_hapus: false,
        file_old :'',
  
        UMUM : UMUM,
        DATA_MASTER : DATA_MASTER,
  
        btn_add: false,
  
  
        tab: 'lampiran',
  
  
        loadRiwayatSIA : true,
        fileLoadSIA : true,
        fileLoadEmpty : false,
        fileRiwayat : null,
        // kodeDok : '882',
  
  
        status :1,
        datax : {
          nama : '',
          stat_adm_bkd : '',
          ket_adm_bkd : '',

          stat_tim_eval : '',
          ket_tim_eval : '',
        },
  
  
  
      };
    },
  
    methods: {
      getView: function(){
  
        this.loadRiwayatSIA = true;

          fetch(this.$store.state.url.URL_LAMPIRAN_MUTASI_OPD+'view', {
              method : 'POST',
              headers : {
                "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
              },
              body : JSON.stringify({
                mutasi_id : this.form.mutasi_id,
              })
          }).then((res) => res.json()).then((res_data) => {
            this.list_riwayat = res_data;
            this.loadRiwayatSIA = false;
            // console.log(res_data);
          })
      },
  
      addData : function(number) {
  
        var formData = new FormData();
        formData.append('mutasi_id', this.form.mutasi_id);
        formData.append('uraian', this.form.uraian);
        formData.append('file', this.form.file);
        formData.append('file_type', this.form.file_type);
        formData.append('nip', this.nip);
  
        fetch(this.$store.state.url.URL_LAMPIRAN_MUTASI_OPD+'addData', {
            method: "POST",
            headers: {
                authorization : 'kikensbatara '+localStorage.token
            },
            body: formData
        }).then(res => res.json()).then((data_urusan) => {
            this.Notify('Sukses Menambah Data', 'primary', 'check_circle_outline');
            this.getView();
        });
       
      },
  
  
      editData : function(){
  
        var formData = new FormData();
        formData.append('id', this.form.id);
        formData.append('mutasi_id', this.form.mutasi_id);
        formData.append('uraian', this.form.uraian);
        formData.append('file', this.form.file);
        formData.append('file_type', this.form.file_type);
        formData.append('nip', this.nip);
        formData.append('file_old', this.file_old);
  
        fetch(this.$store.state.url.URL_LAMPIRAN_MUTASI_OPD+'editData', {
            method: "POST",
            headers: {
                authorization : 'kikensbatara '+localStorage.token
            },
            body: formData
        }).then((res_data) => {
            this.Notify('Sukses Merubah Data', 'warning', 'check_circle_outline');
            this.getView();
        });
      },
  
      removeData : function(E){
        fetch(this.$store.state.url.URL_LAMPIRAN_MUTASI_OPD + "removeData", {
            method: "POST",
            headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify({id : this.form.id, file : this.file_old})
        }).then(res_data => {
            this.Notify('Sukses Menghapus Data', 'negative', 'check_circle_outline');
            this.getView();
        });
  
      },

      getPemohon : function(){
        // console.log("asu");
        fetch(this.$store.state.url.URL_MUTASI_OPD + "viewPemohon", {
            method: "POST",
            headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify({
                
            })
        })
            .then(res => res.json())
            .then(res_data => {
                // console.log(res_data);
                var data = res_data[0];
                // console.log("============================");
                // console.log(data);
                // console.log("============================");

                this.datax.stat_adm_bkd = data.stat_adm_bkd;
                this.datax.ket_adm_bkd = data.ket_adm_bkd;
                this.datax.stat_tim_eval = data.stat_tim_eval;
                this.datax.ket_tim_eval = data.ket_tim_eval;
        });
      },

      selectRiwayat : function(data){
        // console.log("=======================");  
        // console.log(data)
        // console.log("=======================");  
          this.getPemohon(data.id)

          this.form.id = data.id;
          this.form.instansi = data.instansi;
          this.form.unit_kerja = data.unit_kerja;
          this.form.alasan = data.alasan;
          this.form.uraian = data.uraian;
          this.form.mutasi_id = data.mutasi_id;
          this.form.file = data.file;

          this.file_old = data.file;

      
      },
  
  
      // assu : function(){
      //   console.log("aaaassssuuuu");
      // },
  
  
  
      alertku: function(message, positive, icon) {
          this.$q.notify({
            message: message,
            color: positive,
            icon: icon,
            position: "top",
            timeout: 500  
          });
      },
  
      Notify: function(message, positive, icon) {
        this.$q.notify({
          message: message,
          color: positive,
          icon: icon,
          position: "top",
          timeout: 500
        });
      },
  
    },
  
  
    mounted () {
      this.getView()
      // DATA_MASTER.getLatStruktural();
      // DATA_MASTER.getJnsKompetensi();
    },
  
  
  
  };
  